<template>
    <!-- pk形式 -->
        <div class="pk">
            <div class="tabbar">
                <div class="tabbar-item"  :class="tabIndex==index?'tabbar-item-active':''" @click="handleChange(index)" v-for="(tab,index) in technicalDetails" :key="index">{{tab.rounds}}</div>
            </div>
            <div class="data">
                <div class="data-left">
                    <template  v-for="(item,index) in technicalDetails[tabIndex].technicalDatas" >
                        <div class="data-item" :key="index" >
                            <span class="text score">{{index}}</span>
                            <span class="press">
                                <span class="blue" :style="{width:(Number(item.blueScore) / (Number(item.blueScore) + Number(item.redScore)) * 110) + 'px'}"></span>
                                <template v-if="item.blueScore!=0">
                                    <span class="gray" :style="{width:(Number(item.redScore) / (Number(item.blueScore) + Number(item.redScore)) * 110) + 'px'}"></span>
                                </template>
                                 <template v-else>
                                    <span class="gray" :style="{width:1 * 110 + 'px'}"></span>
                                </template>
                                
                            </span>
                            <span class="text" style="margin-right:20px">{{item.blueScore}}</span>
                            <span class="press">
                                <span class="red" :style="{width:(Number(item.redScore) / (Number(item.blueScore) + Number(item.redScore)) * 110) + 'px'}"></span>
                                  <template v-if="item.redScore!=0">
                                   <span class="gray" :style="{width:(Number(item.blueScore) / (Number(item.blueScore) + Number(item.redScore)) * 110) + 'px'}"></span>
                                </template>
                                 <template v-else>
                                   <span class="gray" :style="{width:1 * 110 + 'px'}"></span>
                                </template>
                                
                            </span>
                            <span class="text num">{{item.redScore}}</span>
                        </div>
                     </template>
                </div>
                <MyCharts ref="chlid" v-if="ordarOption" :eWidth="500" :eHight="480" :option="ordarOption" ></MyCharts>
                <!-- <div class="dot fist">
                    <div class="row">
                        <span class="red"></span>88
                     </div> 
                    <div class="row">
                         <span class="blue"></span>66
                    </div>
                </div>
                <div class="dot header">
                     <div class="row">
                        <span class="red"></span>88
                     </div> 
                    <div class="row">
                         <span class="blue"></span>66
                    </div>         
                </div>
                <div class="dot warn">
                     <div class="row">
                        <span class="red"></span>88
                     </div> 
                    <div class="row">
                         <span class="blue"></span>66
                    </div>         
                </div>
                <div class="dot rotate">
                     <div class="row">
                        <span class="red"></span>88
                     </div> 
                    <div class="row">
                         <span class="blue"></span>66
                    </div>         
                </div>
                <div class="dot trunk">
                     <div class="row">
                        <span class="red"></span>88
                     </div> 
                    <div class="row">
                         <span class="blue"></span>66
                    </div>         
                </div> -->
            </div>
        </div>
</template>

<script>
import MyCharts from '../../myecharts/MyEcharts'
export default {
  props:['eWidth','eHight','technicalDetails'],
  components:{MyCharts},
  data () {
    return {
      tabIndex: 0,
      ordarOption: {
        color: ['#E51924', '#2773D5'],
        tooltip: {
          show: true
        },
        legend: {},
        radar: {
          radius:150,
          indicator:[],
          axisName: {
            color: '#333',
            fontSize: 14,
            fontWeight: 700,
          }
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: [],
                name: '红队',
                lineStyle: {
                //   type: 'dashed',
                  color: '#E51924',
                  opacity: 0.8
                },
                symbolSize: 0,
                areaStyle: {
                  color: '#E51924'
                }
              },
              {
                value: [],
                name: '蓝队',
                symbolSize: 0,
                lineStyle: {
                  color:'#2773D5',
                  //   type: 'dashed',
                  opacity: 0.8
                },
                areaStyle: {
                  color: '#2773D5'
                }
              }
            ]
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    handleChange (index) {
      this.tabIndex=index
      //更新ehcarts参数
      //   this.getEchartsData()
      //重新渲染echarts
    //   this.$refs.chlid.initData()
    },
    getEchartsData (){
      let indicator=[]
      let redScore=[]
      let blueScore=[]
      let scoreObject={}
      let arr = ['一分次数','两分次数','三分次数','起手式得分次数','警告','严重警告','驱逐出场']
      //合并分数
      for(let item in this.technicalDetails){
        arr.forEach(element => {
          if (scoreObject[element] && this.technicalDetails[item].technicalDatas[element]) {
            scoreObject[element].blueScore += Number(this.technicalDetails[item].technicalDatas[element].blueScore)
            scoreObject[element].redScore += Number(this.technicalDetails[item].technicalDatas[element].redScore)
          } else {
            scoreObject[element] = {
              blueScore: this.technicalDetails[item].technicalDatas[element] ? Number(this.technicalDetails[item].technicalDatas[element].blueScore) : 0,
              redScore:this.technicalDetails[item].technicalDatas[element] ? Number(this.technicalDetails[item].technicalDatas[element].redScore) : 0,
            }
          }
          
        })
      }
      //echarts value的max值处理
      let maxNum=0
      for (let item in scoreObject){
        let obj={}
        if(item!=='总力度'&&item!=='最大力度'&&item!=='小局得分'){
      
          if(scoreObject[item].blueScore>maxNum||scoreObject[item].redScore>maxNum){
            console.log('11',scoreObject[item].blueScore)
            console.log('22',scoreObject[item].redScore)
            maxNum=scoreObject[item].blueScore>scoreObject[item].redScore?scoreObject[item].blueScore:scoreObject[item].redScore
          }
          obj.name=item
          obj.max=0
          indicator.push(obj)
        }
      }
      console.log(maxNum)
      for (let item in indicator){
        indicator[item].max=maxNum
      }
      //分数处理blueScore
      for(let key in scoreObject){
        console.log(scoreObject[key])
        let score=Number(scoreObject[key].blueScore)
        if(score>100){
          score=100
        }
        blueScore.push(score)
      }
      //分数处理redScore
      for(let key in scoreObject){
        let score=Number(scoreObject[key].redScore)
        if(score>100){
          score=100
        }
        redScore.push(score)
      }
      this.ordarOption.radar.indicator=indicator
      this.ordarOption.series[0].data[0].value=redScore
      this.ordarOption.series[0].data[1].value=blueScore
      console.log(this.ordarOption)
    }
    // getEchartsData (){
    //   let indicator=[]
    //   let redScore=[]
    //   let blueScore=[]
    //   for(let item in this.technicalDetails[this.tabIndex].technicalDatas){
    //     let obj={}
    //     if(item!=='总力度'&&item!=='最大力度'){
    //       obj.name=item
    //       obj.max=100
    //       indicator.push(obj)
    //     } 
    //   }
    //   for(let key in this.technicalDetails[this.tabIndex].technicalDatas){
    //     let score=Number(this.technicalDetails[this.tabIndex].technicalDatas[key].blueScore)
    //     if(score>100){
    //       score=100
    //     }
    //     blueScore.push(score)
    //   }
    //   for(let key in this.technicalDetails[this.tabIndex].technicalDatas){
    //     let score=Number(this.technicalDetails[this.tabIndex].technicalDatas[key].redScore)
    //     if(score>100){
    //       score=100
    //     }
    //     redScore.push(score)
    //   }
    //   this.ordarOption.radar.indicator=indicator
    //   this.ordarOption.series[0].data[0].value=redScore
    //   this.ordarOption.series[0].data[1].value=blueScore
    // }
  },
  mounted () {
    this.getEchartsData()
  },
}
</script>

<style lang="scss" scoped>
//-----pk样式
.pk{
    //tabbar
    .tabbar{
        display: flex;
        box-sizing: border-box;
        justify-content: flex-start;
        width: 100%;
         height: 50px;
        .tabbar-item{
            background-color: #F1F1F1;
            box-sizing: border-box;
            max-width: 120px;
            width: 95%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #333333;
            font-weight: bold;
            cursor: pointer;
            margin-right: 5px;
        }
        &last-child{
            margin-right: 0 !important;
        }
        .tabbar-item-active{
            border-bottom: 4px solid #2773D5;
        }
    }
    //显示数据
    .data{
        width: 100%;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        // position: relative;
        .data-left{
            width: 50%;
            box-sizing: border-box;
            padding: 50px 0 50px  50px;
            height: 100%;
            .data-item{
                display: flex;
                margin-top: 10px;
                font-size: 14px;
                height: 24px;
                box-sizing: border-box;
                line-height: 24px;
                span{
                    display: inline-block;
                }
                .score{
                    font-weight: bold;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .text{
                    color:#333333;
                    font-weight: 600;
                    width: 66px;
                    height: 100%;
                }
                .press{
                    width: 110px;
                    height: 24px;
                    display: flex;
                    justify-content: flex-start;
                    line-height: 24px;
                    align-items: center;
                    margin-right: 15px;
                }
                .gray{
                    background-color: #eee;
                    height: 14px;
                }
                .red{
                    background-color: #E51924;
                    height: 14px;
                }
                .blue{
                    background-color: #2773D5;
                    height: 14px;
                }
            }
        }
        // 小点样式
        .dot{
            display: flex;
            justify-content: space-between;
            position: absolute;
            font-size: 14px;
            color: #333333;
            .row{
                width: 40px;
            }
            .blue{
                width: 10px;
                height: 10px;
                background-color: #275EAA;
                display: inline-block;
                margin-right: 3px;
            }
            .red{
                width: 10px;
                display: inline-block;
                height: 10px;
                margin-right: 3px;
                background-color: #E51924;
            }
        }
        .fist{
            top: 10px;
            right: 160px;
        }
        .header{
            top: 180px;
            right: 430px;
        }
        .warn{
            top: 380px;
            right: 336px;
        }
        .rotate{
            top: 380px;
            right: 80px;
        }
        .trunk{
            top: 180px;
            right: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/military/content/FightContent.vue